import cn from "@utils/cn";
import { useTranslations } from "next-intl";
import Image from "next/image";
import { ChangeEvent, FC, useEffect, useState } from "react";

import { BeedromFiltersProps, SearchParams } from "@/types";

import { useGuidedToolContext } from "./GuidedToolProvider";

const BeedromFilters: FC<BeedromFiltersProps> = ({ options, slideId }) => {
  const { setCurrentFilter, activeSlideId } = useGuidedToolContext();
  const [selectedElement, setSelectedElement] = useState<string[]>([]);
  const t = useTranslations();

  useEffect(() => {
    if (activeSlideId == slideId) {
      // console.log(selectedElement);
      setCurrentFilter({ bedrooms: selectedElement.toString() } as SearchParams);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedElement, activeSlideId, slideId]);

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    const { checked, value } = e.target;

    setSelectedElement((prevSelected) => (checked ? [...prevSelected, value] : prevSelected.filter((item) => item !== value)));
  };

  return (
    <div className="md:w-fit md:mx-auto">
      <div className="mt-xl grid grid-cols-3 md:grid-cols-5 gap-m justify-items-center">
        {options.map((option, i) => {
          const isChecked = selectedElement.includes(`${option.value}`);
          return (
            <div
              key={i}
              className={cn(
                "border-gray-10 border rounded-full overflow-hidden relative flex flex-col justify-center items-center h-[94px] w-[94px] lg:h-[134px] lg:w-[134px] group beedrom-filter",
                isChecked ? "bg-gold-gradient text-black border-gold" : "hover:gray-gradient hover:text-black border-gray-10",
              )}
            >
              <Image
                src={"/assets/guided-tool-beedrom.svg"}
                width={64}
                height={64}
                alt={`${option.value}`}
                className={cn("h-auto block group-hover:invert max-w-[60%]", isChecked && "invert")}
              />
              <div className="font-medium text-s lg:text-m beedroom-filter__label">
                {option.value === "0" ? t("guidedtool.studio") : option.value}
              </div>
              <input
                aria-label={`${option.value}`}
                name={`${option.value}`}
                value={option.value}
                className="absolute w-full h-full appearance-none top-0 left-0 z-10 hover:cursor-pointer"
                onChange={handleChange}
                type={"checkbox"}
                checked={isChecked}
              />
            </div>
          );
        })}
      </div>
    </div>
  );
};
export default BeedromFilters;
